<div class="certificate-liability-cover-provision flex flex-col gap-6"
     [formGroup]="form()"
>
  <div class="comparison-grid expanded-mode"
       data-test="certificate-liability-cover-provision-comparison-grid-0"
  >
    <div *albertIfCategory="'cslOnCertificateAmount'; config: visibility">
      <albert-input-wrapper data-test="wrapper-certificate-liability-cover-provision-csl-on-certificate-amount"
                            groupName="cslOnCertificateAmount"
                            tooltipLabel="CSL on Certificate Amount"
                            [disabled]="!canEdit()"
      >
        <albert-limit class="flex-1"
                      currencyControlName="cslOnCertificateAmount.currency"
                      currencyGroupName="cslOnCertificateAmount.currency"
                      currencyInputId="cslOnCertificateAmountCurrency"
                      currencyLabel="Currency"
                      limitControlName="cslOnCertificateAmount.amount"
                      limitGroupName="cslOnCertificateAmount.amount"
                      limitInputId="cslOnCertificateAmountLimit"
                      limitLabel="CSL on Certificate Amount"
                      [disabled]="!canEdit()"
        />
      </albert-input-wrapper>
    </div>
    <div *albertIfCategory="'avn52eTotalLimitAmount'; config: visibility"
         class="override-cell"
    >
      <albert-input-wrapper data-test="wrapper-certificate-liability-cover-provision-avn52e-total-limit-amount"
                            groupName="avn52eTotalLimitAmount"
                            tooltipLabel="AVN52E Total Limit Amount"
                            [disabled]="!canEdit() || avn52eTotalLimitLocked()"
      >
        <albert-limit class="flex-1"
                      currencyControlName="avn52eTotalLimitAmount.currency"
                      currencyGroupName="avn52eTotalLimitAmount.currency"
                      currencyInputId="avn52eTotalLimitAmountCurrency"
                      currencyLabel="Currency"
                      limitControlName="avn52eTotalLimitAmount.amount"
                      limitGroupName="avn52eTotalLimitAmount.amount"
                      limitInputId="avn52eTotalLimitAmountLimit"
                      limitLabel="AVN52E Total Limit Amount"
                      [disabled]="!canEdit() || avn52eTotalLimitLocked()"
        />
      </albert-input-wrapper>
    </div>
  </div>
  @if (categoryService.activeCertificateCategory() === CertificateCategory.AUTHORITIES ||
  categoryService.activeCertificateCategory() === CertificateCategory.CONTRACTUAL) {
    <div class="comparison-grid expanded-mode"
         data-test="certificate-liability-cover-provision-comparison-grid-1"
    >
      <div>
        <albert-checkbox *albertIfCategory="'liabilityLimitsPerAircraftType'; config: visibility"
                         controlName="liabilityLimitsPerAircraftType"
                         data-test="certificate-liability-cover-provision-limits-per-aircraft-type"
                         groupName="liabilityLimitsPerAircraftType"
                         inputId="liabilityLimitsPerAircraftType"
                         label="Show Limits per Aircraft Type"
                         [disabled]="!canEdit()"
        />
      </div>
      <div class="override-cell">
        <div class="flex flex-col gap-2">
          <albert-checkbox *albertIfCategory="'liabilityAvn52eVariousLimits'; config: visibility"
                           controlName="liabilityAvn52eVariousLimits"
                           data-test="certificate-liability-cover-provision-avn52e-various-limits"
                           groupName="liabilityAvn52eVariousLimits"
                           inputId="liabilityAvn52eVariousLimits"
                           label="AVN52E Various Limits"
                           [disabled]="!canEdit()"
          />
          <albert-checkbox *albertIfCategory="'liabilityAvn52eLimitsFleetList'; config: visibility"
                           controlName="liabilityAvn52eLimitsFleetList"
                           data-test="certificate-liability-cover-provision-avn52e-limits-fleetlist"
                           groupName="liabilityAvn52eLimitsFleetList"
                           inputId="liabilityAvn52eLimitsFleetList"
                           label="Show Limits on Attached Fleet List"
                           [disabled]="!canEdit()"
          />
        </div>
      </div>

      @if (showAircraftTypeLimits()) {
        <!-- Aircraft type left, its limit right; on mobile the single column puts the limit below its type. -->
        @for (pair of pagedAircraftTypeLimits(); track pair.limitGroup) {
          <div>
            <albert-input groupName="liabilityAircraftType"
                          [attr.data-test]="'certificate-liability-cover-provision-liability-aircraft-type-' + (pair.index + 1)"
                          [controlName]="pair.typeControlName"
                          [disabled]="true"
                          [inputId]="'liabilityAircraftType' + (pair.index + 1)"
                          [label]="'Aircraft Type #' + (pair.index + 1)"
            />
          </div>
          <div class="override-cell flex flex-row gap-4 items-end"
               [formGroup]="pair.limitGroup"
          >
            <albert-limit class="flex-1"
                          currencyControlName="currency"
                          currencyGroupName="currency"
                          currencyLabel="Currency"
                          limitControlName="amount"
                          limitGroupName="amount"
                          [attr.data-test]="'certificate-liability-cover-provision-liability-limit-amount-aircraft-' + (pair.index + 1)"
                          [currencyInputId]="'liabilityLimitAmountAircraftCurrency' + (pair.index + 1)"
                          [disabled]="!canEdit()"
                          [limitInputId]="'liabilityLimitAmountAircraft' + (pair.index + 1)"
                          [limitLabel]="'Limit Amount Aircraft Type #' + (pair.index + 1)"
            />
            <button class="clear-input-btn"
                    iconOnly
                    pButton
                    severity="secondary"
                    type="button"
                    [attr.data-test]="'certificate-liability-cover-provision-remove-aircraft-type-limit-' + (pair.index + 1)"
                    [disabled]="!canEdit()"
                    [outlined]="true"
                    (click)="onClearAircraftTypeLimit(pair.index)"
            >
              <i class="pi pi-times"></i>
            </button>
          </div>
        }
      }
    </div>

    @if (showAircraftTypeLimits() && liabilityLimitAmountAircraft.length > aircraftTypeLimitRows) {
      <p-paginator data-test="certificate-liability-cover-provision-aircraft-type-limit-paginator"
                   [first]="aircraftTypeLimitFirst()"
                   [rows]="aircraftTypeLimitRows"
                   [totalRecords]="liabilityLimitAmountAircraft.length"
                   (onPageChange)="onAircraftTypePageChange($event)"
      />
    }
  }
  <div class="comparison-grid expanded-mode"
       data-test="certificate-liability-cover-provision-comparison-grid-2"
  >
    <div *albertIfCategory="'personalInjuryAmount'; config: visibility">
      <albert-input-wrapper data-test="wrapper-certificate-liability-cover-provision-personal-injury-amount"
                            groupName="personalInjuryAmount"
                            tooltipLabel="Personal Injury Amount"
                            [disabled]="!canEdit()"
      >
        <albert-limit class="flex-1"
                      currencyControlName="personalInjuryAmount.currency"
                      currencyGroupName="personalInjuryAmount.currency"
                      currencyInputId="personalInjuryAmountCurrency"
                      currencyLabel="Currency"
                      limitControlName="personalInjuryAmount.amount"
                      limitGroupName="personalInjuryAmount.amount"
                      limitInputId="personalInjuryAmountLimit"
                      limitLabel="Personal Injury Amount"
                      [disabled]="!canEdit()"
        />
      </albert-input-wrapper>
    </div>
    <div *albertIfCategory="'groundingLiabilityAmount'; config: visibility"
         class="override-cell"
    >
      <albert-input-wrapper data-test="wrapper-certificate-liability-cover-provision-grounding-liability-amount"
                            groupName="groundingLiabilityAmount"
                            tooltipLabel="Grounding Liability Amount"
                            [disabled]="!canEdit()"
      >
        <albert-limit class="flex-1"
                      currencyControlName="groundingLiabilityAmount.currency"
                      currencyGroupName="groundingLiabilityAmount.currency"
                      currencyInputId="groundingLiabilityAmountCurrency"
                      currencyLabel="Currency"
                      limitControlName="groundingLiabilityAmount.amount"
                      limitGroupName="groundingLiabilityAmount.amount"
                      limitInputId="groundingLiabilityAmountLimit"
                      limitLabel="Grounding Liability Amount"
                      [disabled]="!canEdit()"
        />
      </albert-input-wrapper>
    </div>
    <div *albertIfCategory="'passengerBaggageDeductibleAmount'; config: visibility">
      <albert-input-wrapper data-test="wrapper-certificate-liability-cover-provision-passenger-baggage-deductible-amount"
                            groupName="passengerBaggageDeductibleAmount"
                            tooltipLabel="Passenger Baggage Deductible Amount"
                            [disabled]="!canEdit()"
      >
        <albert-limit class="flex-1"
                      currencyControlName="passengerBaggageDeductibleAmount.currency"
                      currencyGroupName="passengerBaggageDeductibleAmount.currency"
                      currencyInputId="passengerBaggageDeductibleAmountCurrency"
                      currencyLabel="Currency"
                      limitControlName="passengerBaggageDeductibleAmount.amount"
                      limitGroupName="passengerBaggageDeductibleAmount.amount"
                      limitInputId="passengerBaggageDeductibleAmountLimit"
                      limitLabel="Passenger Baggage Deductible Amount"
                      [disabled]="!canEdit()"
        />
      </albert-input-wrapper>
    </div>
    <div *albertIfCategory="'cargoAndMailDeductibleAmount'; config: visibility"
         class="override-cell"
    >
      <albert-input-wrapper data-test="wrapper-certificate-liability-cover-provision-cargo-mail-deductible-amount"
                            groupName="cargoAndMailDeductibleAmount"
                            tooltipLabel="Cargo & Mail Deductible Amount"
                            [disabled]="!canEdit()"
      >
        <albert-limit class="flex-1"
                      currencyControlName="cargoAndMailDeductibleAmount.currency"
                      currencyGroupName="cargoAndMailDeductibleAmount.currency"
                      currencyInputId="cargoAndMailDeductibleAmountCurrency"
                      currencyLabel="Currency"
                      limitControlName="cargoAndMailDeductibleAmount.amount"
                      limitGroupName="cargoAndMailDeductibleAmount.amount"
                      limitInputId="cargoAndMailDeductibleAmountLimit"
                      limitLabel="Cargo & Mail Deductible Amount"
                      [disabled]="!canEdit()"
        />
      </albert-input-wrapper>
    </div>
    @if (categoryService.activeCertificateCategory() !== CertificateCategory.LSG) {
      <div *albertIfCategory="'avn59Amount'; config: visibility">
        <albert-input-wrapper data-test="wrapper-certificate-liability-cover-provision-avn59-amount"
                              groupName="avn59Amount"
                              tooltipLabel="AVN59 Amount"
                              [disabled]="!canEdit()"
        >
          <albert-limit class="flex-1"
                        currencyControlName="avn59Amount.currency"
                        currencyGroupName="avn59Amount.currency"
                        currencyInputId="avn59AmountCurrency"
                        currencyLabel="Currency"
                        limitControlName="avn59Amount.amount"
                        limitGroupName="avn59Amount.amount"
                        limitInputId="avn59AmountLimit"
                        limitLabel="AVN59 Amount"
                        [disabled]="!canEdit()"
          />
        </albert-input-wrapper>
      </div>
    }
    <div class="override-cell">
      @if (categoryService.activeCertificateCategory() === CertificateCategory.LSG) {
        <albert-input-wrapper data-test="wrapper-certificate-liability-cover-provision-avn59-amount"
                              groupName="avn59Amount"
                              tooltipLabel="AVN59 Amount"
                              [disabled]="!canEdit()"
        >
          <albert-limit class="flex-1"
                        currencyControlName="avn59Amount.currency"
                        currencyGroupName="avn59Amount.currency"
                        currencyInputId="avn59AmountCurrency"
                        currencyLabel="Currency"
                        limitControlName="avn59Amount.amount"
                        limitGroupName="avn59Amount.amount"
                        limitInputId="avn59AmountLimit"
                        limitLabel="AVN59 Amount"
                        [disabled]="!canEdit()"
          />
        </albert-input-wrapper>
      }
    </div>
    <div *albertIfCategory="'sublimitLiquidLiabilityAmount'; config: visibility">
      <albert-input-wrapper data-test="wrapper-certificate-liability-cover-provision-sublimit-liquid-liability-amount"
                            groupName="sublimitLiquidLiabilityAmount"
                            tooltipLabel="Sublimit Liquid Liability Amount"
                            [disabled]="!canEdit()"
      >
        <albert-limit class="flex-1"
                      currencyControlName="sublimitLiquidLiabilityAmount.currency"
                      currencyGroupName="sublimitLiquidLiabilityAmount.currency"
                      currencyInputId="sublimitLiquidLiabilityAmountCurrency"
                      currencyLabel="Currency"
                      limitControlName="sublimitLiquidLiabilityAmount.amount"
                      limitGroupName="sublimitLiquidLiabilityAmount.amount"
                      limitInputId="sublimitLiquidLiabilityAmountLimit"
                      limitLabel="Sublimit Liquid Liability Amount"
                      [disabled]="!canEdit()"
        />
      </albert-input-wrapper>
    </div>
    <div *albertIfCategory="'deductibleAllLossesAmount'; config: visibility"
         class="override-cell"
    >
      <albert-input-wrapper data-test="wrapper-certificate-liability-cover-provision-deductible-all-losses-amount"
                            groupName="deductibleAllLossesAmount"
                            tooltipLabel="Deductible (all losses) Amount"
                            [disabled]="!canEdit()"
      >
        <albert-limit class="flex-1"
                      currencyControlName="deductibleAllLossesAmount.currency"
                      currencyGroupName="deductibleAllLossesAmount.currency"
                      currencyInputId="deductibleAllLossesAmountCurrency"
                      currencyLabel="Currency"
                      limitControlName="deductibleAllLossesAmount.amount"
                      limitGroupName="deductibleAllLossesAmount.amount"
                      limitInputId="deductibleAllLossesAmountLimit"
                      limitLabel="Deductible (all losses) Amount"
                      [disabled]="!canEdit()"
        />
      </albert-input-wrapper>
    </div>

  </div>

  <div class="comparison-grid expanded-mode"
       data-test="certificate-liability-cover-provision-comparison-grid-3"
  >
    <div class="block md:flex md:flex-row w-full justify-between">
      <albert-checkbox *albertIfCategory="'standardCoverPackage'; config: visibility"
                       controlName="standardCoverPackage"
                       data-test="certificate-liability-cover-provision-standard-cover-package"
                       groupName="standardCoverPackage"
                       inputId="standardCoverPackage"
                       label="Standard Cover Package (Lease)"
                       [disabled]="!canEdit()"
      />
      <div appendTo="body"
           pTooltip="Third Party, Passenger, Cargo & Mail"
           tooltipPosition="top"
      >
        <albert-checkbox *albertIfCategory="'standardCoverPackageAirline'; config: visibility"
                         controlName="standardCoverPackageAirline"
                         data-test="certificate-liability-cover-provision-standard-cover-package-airline"
                         groupName="standardCoverPackageAirline"
                         inputId="standardCoverPackageAirline"
                         label="Standard Cover Package (Airline)"
                         [disabled]="!canEdit()"
        />
      </div>
      <div appendTo="body"
           pTooltip="Products, Hangarkeepers, Aviation Premises"
           tooltipPosition="top"
      >
        <albert-checkbox *albertIfCategory="'standardCoverPackageMro'; config: visibility"
                         controlName="standardCoverPackageMro"
                         data-test="certificate-liability-cover-provision-standard-cover-package-mro"
                         groupName="standardCoverPackageMro"
                         inputId="standardCoverPackageMro"
                         label="Standard Cover Package (MRO)"
                         [disabled]="!canEdit()"
        />
      </div>
    </div>
    <div *albertIfCategory="'eu785CoverPackage'; config: visibility"
         class="override-cell"
    >
      <albert-input-wrapper data-test="wrapper-certificate-liability-cover-provision-eu785-cover-package"
                            groupName="eu785CoverPackage"
                            tooltipLabel="EU 785 Cover Package"
                            [disabled]="!canEdit()"
      >
        <albert-select controlName="eu785CoverPackage"
                       data-test="certificate-liability-cover-provision-eu785-cover-package"
                       inputId="eu785CoverPackage"
                       label="EU 785 Cover Package"
                       [disabled]="!canEdit()"
                       [options]="eu785CoverPackageOptions"
        />
      </albert-input-wrapper>
    </div>
    <div></div>
    <div *albertIfCategory="'sdrAmount'; config: visibility"
         class="override-cell"
    >
      <albert-input-wrapper data-test="wrapper-certificate-liability-cover-provision-sdr-amount"
                            groupName="sdrAmount"
                            tooltipLabel="SDR Amount"
                            [disabled]="!canEdit() || !sdrEnabled()"
      >
        <albert-limit class="flex-1"
                      currencyControlName="sdrAmount.currency"
                      currencyGroupName="sdrAmount.currency"
                      currencyInputId="sdrAmountCurrency"
                      currencyLabel="Currency"
                      limitControlName="sdrAmount.amount"
                      limitGroupName="sdrAmount.amount"
                      limitInputId="sdrAmountLimit"
                      limitLabel="SDR Amount"
                      [currencyDisabled]="true"
                      [disabled]="!canEdit() || !sdrEnabled()"
                      [required]="true"
        />
      </albert-input-wrapper>
    </div>
  </div>

  <div class="comparison-grid expanded-mode"
       data-test="certificate-liability-cover-provision-comparison-grid-4"
  >
    <div>
      @if (categoryService.activeCertificateCategory() !== CertificateCategory.LSG) {
        <div class="comparison-grid expanded-mode"
             data-test="certificate-liability-cover-provision-comparison-grid-4-1"
        >
          <div class="flex flex-col gap-2">
            <albert-checkbox *albertIfCategory="'aircraftThirdPartyLiability'; config: visibility"
                             controlName="aircraftThirdPartyLiability"
                             data-test="certificate-liability-cover-provision-aircraft-third-party-liability"
                             groupName="aircraftThirdPartyLiability"
                             inputId="aircraftThirdPartyLiability"
                             label="Aircraft Third Party Liability"
                             [disabled]="!canEdit()"
            />
            <albert-checkbox *albertIfCategory="'avn52ePrimaryLimit'; config: visibility"
                             controlName="avn52ePrimaryLimit"
                             data-test="certificate-liability-cover-provision-avn52e-primary-limit"
                             groupName="avn52ePrimaryLimit"
                             inputId="avn52ePrimaryLimit"
                             label="AVN52E Primary Limit"
                             [disabled]="!canEdit()"
            />
            <albert-checkbox *albertIfCategory="'passengerLiability'; config: visibility"
                             controlName="passengerLiability"
                             data-test="certificate-liability-cover-provision-passenger-liability"
                             groupName="passengerLiability"
                             inputId="passengerLiability"
                             label="Passenger Liability"
                             [disabled]="!canEdit()"
            />
            <albert-checkbox *albertIfCategory="'personalInjury'; config: visibility"
                             controlName="personalInjury"
                             data-test="certificate-liability-cover-provision-personal-injury"
                             groupName="personalInjury"
                             inputId="personalInjury"
                             label="Personal Injury"
                             [disabled]="!canEdit()"
            />
            <albert-checkbox *albertIfCategory="'cargoAndMailLiability'; config: visibility"
                             controlName="cargoAndMailLiability"
                             data-test="certificate-liability-cover-provision-cargo-mail-liability"
                             groupName="cargoAndMailLiability"
                             inputId="cargoAndMailLiability"
                             label="Cargo & Mail Liability"
                             [disabled]="!canEdit()"
            />
          </div>
          <div class="override-cell flex flex-col gap-2">
            <albert-checkbox *albertIfCategory="'hangarkeepersLiability'; config: visibility"
                             controlName="hangarkeepersLiability"
                             data-test="certificate-liability-cover-provision-hangarkeepers-liability"
                             groupName="hangarkeepersLiability"
                             inputId="hangarkeepersLiability"
                             label="Hangarkeepers Liability"
                             [disabled]="!canEdit()"
            />
            <albert-checkbox *albertIfCategory="'productsLiability'; config: visibility"
                             controlName="productsLiability"
                             data-test="certificate-liability-cover-provision-products-liability"
                             groupName="productsLiability"
                             inputId="productsLiability"
                             label="Products Liability"
                             [disabled]="!canEdit()"
            />
            <albert-checkbox *albertIfCategory="'productsCompletedOperationsLiability'; config: visibility"
                             controlName="productsCompletedOperationsLiability"
                             data-test="certificate-liability-cover-provision-products-completed-operations"
                             groupName="productsCompletedOperationsLiability"
                             inputId="productsCompletedOperationsLiability"
                             label="Products / Compl. Operations Liability"
                             [disabled]="!canEdit()"
            />
            <albert-checkbox *albertIfCategory="'motorLiabilityNonRegistered'; config: visibility"
                             controlName="motorLiabilityNonRegistered"
                             data-test="certificate-liability-cover-provision-motor-liability-non-registered"
                             groupName="motorLiabilityNonRegistered"
                             inputId="motorLiabilityNonRegistered"
                             label="Motor Liability non-registered"
                             [disabled]="!canEdit()"
            />
            <albert-checkbox *albertIfCategory="'motorLiabilityRegistered'; config: visibility"
                             controlName="motorLiabilityRegistered"
                             data-test="certificate-liability-cover-provision-motor-liability-registered"
                             groupName="motorLiabilityRegistered"
                             inputId="motorLiabilityRegistered"
                             label="Motor Liability registered"
                             [disabled]="!canEdit()"
            />
          </div>
        </div>
      }
      @if (categoryService.activeCertificateCategory() === CertificateCategory.LSG) {
        <div class="flex flex-col gap-2">
          <albert-checkbox *albertIfCategory="'avn52ePrimaryLimit'; config: visibility"
                           controlName="avn52ePrimaryLimit"
                           data-test="certificate-liability-cover-provision-avn52e-primary-limit"
                           groupName="avn52ePrimaryLimit"
                           inputId="avn52ePrimaryLimit"
                           label="AVN52E Primary Limit"
                           [disabled]="!canEdit()"
          />
          <albert-checkbox *albertIfCategory="'personalInjury'; config: visibility"
                           controlName="personalInjury"
                           data-test="certificate-liability-cover-provision-personal-injury"
                           groupName="personalInjury"
                           inputId="personalInjury"
                           label="Personal Injury"
                           [disabled]="!canEdit()"
          />
        </div>
      }
    </div>
    <div class="override-cell flex flex-col gap-2">
      <albert-checkbox *albertIfCategory="'aviationPremiseLiability'; config: visibility"
                       controlName="aviationPremiseLiability"
                       data-test="certificate-liability-cover-provision-aviation-premises-liability"
                       groupName="aviationPremiseLiability"
                       inputId="aviationPremiseLiability"
                       label="Aviation Premises Liability"
                       [disabled]="!canEdit()"
      />
      <albert-checkbox *albertIfCategory="'aviationGeneralThirdPartyLiability'; config: visibility"
                       controlName="aviationGeneralThirdPartyLiability"
                       data-test="certificate-liability-cover-provision-aviation-general-third-party-liability"
                       groupName="aviationGeneralThirdPartyLiability"
                       inputId="aviationGeneralThirdPartyLiability"
                       label="Aviation General Third Party Liability AVN59"
                       [disabled]="!canEdit()"
      />
      <albert-checkbox *albertIfCategory="'contractualLiability'; config: visibility"
                       controlName="contractualLiability"
                       data-test="certificate-liability-cover-provision-contractual-liability"
                       groupName="contractualLiability"
                       inputId="contractualLiability"
                       label="Contractual Liability"
                       [disabled]="!canEdit()"
      />
      <albert-freetext-section *albertIfCategory="'additionalFreetextLiability'; config: visibility"
                               dataTestPrefix="certificate-liability-cover-provision"
                               [form]="form()"
                               [section]="freetextSectionsByKey.additionalFreetextLiability"
      />
    </div>
  </div>

  @if (categoryService.activeCertificateCategory() !== CertificateCategory.LSG) {
    <div class="comparison-grid expanded-mode"
         data-test="certificate-liability-cover-provision-comparison-grid-5"
    >
      <div class="flex flex-col gap-2">
        <albert-checkbox *albertIfCategory="'bhvPrimary'; config: visibility"
                         controlName="bhvPrimary"
                         data-test="certificate-liability-cover-provision-bhv-primary-amount"
                         groupName="bhvPrimary"
                         inputId="bhvPrimary"
                         label="BHV Primary"
                         [disabled]="!canEdit()"
        />
        <albert-input-wrapper *albertIfCategory="'bhvPrimaryAmount'; config: visibility"
                              data-test="wrapper-certificate-liability-cover-provision-bhv-primary-amount"
                              groupName="bhvPrimaryAmount"
                              tooltipLabel="BHV Primary Amount"
                              [disabled]="!canEdit() || !form().controls.bhvPrimary.value"
        >
          <albert-limit class="flex-1"
                        currencyControlName="bhvPrimaryAmount.currency"
                        currencyGroupName="bhvPrimaryAmount.currency"
                        currencyInputId="bhvPrimaryAmountCurrency"
                        currencyLabel="Currency"
                        limitControlName="bhvPrimaryAmount.amount"
                        limitGroupName="bhvPrimaryAmount.amount"
                        limitInputId="bhvPrimaryAmountLimit"
                        limitLabel="BHV Primary Amount"
                        [disabled]="!canEdit() || !form().controls.bhvPrimary.value"
                        [required]="true"
          />
        </albert-input-wrapper>
        <albert-checkbox *albertIfCategory="'bhvExcessOnly'; config: visibility"
                         controlName="bhvExcessOnly"
                         data-test="certificate-liability-cover-provision-bhv-excess-only"
                         groupName="bhvExcessOnly"
                         inputId="bhvExcessOnly"
                         label="BHV Excess Only"
                         [disabled]="!canEdit()"
        />
      </div>
      <div class="override-cell">
        <albert-freetext-section *albertIfCategory="'bhvPrimaryFreetext'; config: visibility"
                                 dataTestPrefix="certificate-liability-cover-provision"
                                 [form]="form()"
                                 [section]="freetextSectionsByKey.bhvPrimaryFreetext"
        />
      </div>
    </div>
  }
  <div class="comparison-grid expanded-mode"
       data-test="certificate-liability-cover-provision-comparison-grid-6"
  >
    <div>
      <albert-freetext-section *albertIfCategory="'additionalInsured'; config: visibility"
                               dataTestPrefix="certificate-liability-cover-provision"
                               [form]="form()"
                               [section]="freetextSectionsByKey.additionalInsured"
      />
    </div>
    <div class="override-cell">
      <albert-freetext-section *albertIfCategory="'primaryClause'; config: visibility"
                               dataTestPrefix="certificate-liability-cover-provision"
                               [form]="form()"
                               [section]="freetextSectionsByKey.primaryClause"
      />
    </div>
    <div>
      <albert-freetext-section *albertIfCategory="'severabilityOfInterest'; config: visibility"
                               dataTestPrefix="certificate-liability-cover-provision"
                               [form]="form()"
                               [section]="freetextSectionsByKey.severabilityOfInterest"
      />
    </div>
    <div class="override-cell">
      <albert-freetext-section *albertIfCategory="'noLiabilityForPremiums'; config: visibility"
                               dataTestPrefix="certificate-liability-cover-provision"
                               [form]="form()"
                               [section]="freetextSectionsByKey.noLiabilityForPremiums"
      />
    </div>
    <div>
      <albert-freetext-section *albertIfCategory="'breachOfWarranty'; config: visibility"
                               dataTestPrefix="certificate-liability-cover-provision"
                               [form]="form()"
                               [section]="freetextSectionsByKey.breachOfWarranty"
      />
    </div>
    <div class="override-cell flex flex-col gap-2">
      <albert-checkbox *albertIfCategory="'noticeOfCancellationInclWar'; config: visibility"
                       controlName="noticeOfCancellationInclWar"
                       data-test="certificate-liability-cover-provision-notice-of-cancellation-incl-war"
                       groupName="noticeOfCancellationInclWar"
                       inputId="certificate-liability-cover-provision-noticeOfCancellationInclWar"
                       label="Notice of Cancellation (incl. War)"
                       [disabled]="!canEdit()"
      />

      <albert-freetext-section *albertIfCategory="'noticeOfCancellationNoWar'; config: visibility"
                               dataTestPrefix="certificate-liability-cover-provision"
                               [form]="form()"
                               [section]="freetextSectionsByKey.noticeOfCancellationNoWar"
      />
    </div>
    <div class="flex flex-col gap-2">
      <albert-checkbox *albertIfCategory="'contingencyCodeshare'; config: visibility"
                       controlName="contingencyCodeshare"
                       data-test="certificate-hull-cover-provision-contingency-codeshare"
                       groupName="contingencyCodeshare"
                       inputId="contingencyCodeshare"
                       label="Contingency Codeshare"
                       [disabled]="!canEdit()"
      />
      <albert-checkbox *albertIfCategory="'waiverOfSubrogation'; config: visibility"
                       controlName="waiverOfSubrogation"
                       data-test="certificate-hull-cover-provision-waiver-of-subrogation"
                       groupName="waiverOfSubrogation"
                       inputId="waiverOfSubrogation"
                       label="Waiver of subrogation"
                       [disabled]="!canEdit()"
      />
    </div>
    <div class="override-cell">
      <albert-freetext-section dataTestPrefix="certificate-liability-cover-provision"
                               [form]="form()"
                               [section]="freetextSectionsByKey.additionalFreetext"
      />
    </div>
  </div>

</div>
